import { render } from "./FooterItem.vue?vue&type=template&id=4866c9ae&scoped=true"
import script from "./FooterItem.vue?vue&type=script&lang=js"
export * from "./FooterItem.vue?vue&type=script&lang=js"

import "./FooterItem.vue?vue&type=style&index=0&id=4866c9ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4866c9ae"]])

export default __exports__